import Button, { ButtonProps } from "@mui/material/Button";
import React from "react";
import "./CuoButton.scss";
import LoadingSpinner from "./LoadingSpinner";

interface CuoButton extends ButtonProps {
  label?: string | React.ReactNode;
  icon?: React.ReactNode;
  disableOnAsync?: boolean;
  buttonColor?: string;
  textColor?: string;
}

export default function CuoButton(props: CuoButton) {
  const {
    label,
    variant = "contained",
    color = "primary",
    buttonColor,
    icon,
    disabled,
    textColor,
    disableOnAsync,
    ...rest
  } = props;
  return (
    <Button
      disableElevation
      disableRipple
      disabled={disableOnAsync || disabled}
      variant={variant}
      color={color}
      className="cuo-button"
      sx={{
        justifyContent: "center",
        color: textColor ?? "",
        ...(!label && { minWidth: "0 !important" }),
        borderColor: variant === "outlined" && buttonColor ? buttonColor : "",
        background: variant === "contained" && buttonColor ? buttonColor : "",
        svg: {
          fontSize: "17px",
        },
        ":hover": {
          borderColor: variant === "outlined" && buttonColor ? buttonColor : "",
          background: variant === "contained" && buttonColor ? buttonColor : "",
        },
      }}
      {...rest}
    >
      {disableOnAsync ? (
        <LoadingSpinner showText={false} size={18} />
      ) : (
        <>
          {icon}
          {label}
        </>
      )}
    </Button>
  );
}
